// linted by Ricky Kim

import React from 'react';
import '../App.css';
import MobileHeader from '../Components/MobileHeader';

export default class Deferment extends React.Component {
    render() {
        return (
            <div>
                <MobileHeader
                    jurorName={this.props.jurorName}
                    jurorReportingDateTime={this.props.jurorReportingDateTime}
                    logOut={this.props.logOut}
                />
                <p />
                <div className="Deferment">
                    Thank you for filling out the questionnaire. Based on your answers, we have determined that you qualify for Deferment and are no
                    longer needed for Jury Duty.
                    <div>
                        <button className="cta_button" onClick={this.props.logOut}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
